import {get, put} from './http';
import type {Analyst} from './shares';

export type ChannelReviewAudience = 'off' | 'selected' | 'everyone';

export type UpdateModerationSettingsPayload = {
  channel_review_audience: ChannelReviewAudience;
  channel_review_analysts: string[];
  lease_seconds: number;
  heartbeat_seconds: number;
  skip_minutes: number;
  batch_sizes: number[];
  queues_enabled: boolean;
};

export type ModerationSettings = UpdateModerationSettingsPayload & {
  channel_review_analyst_details: Analyst[];
  updated_at: string | null;
  updated_by: string | null;
};

export const moderationSettingsApi = {
  get: async () => get<ModerationSettings>('/admin/moderation-settings'),
  update: async (payload: UpdateModerationSettingsPayload) =>
    put<UpdateModerationSettingsPayload, ModerationSettings>('/admin/moderation-settings', payload)
};
